import Vue from 'vue'
import { getApiBasePath } from '@/constants'

export const uploadFile = async ({ callback, ...params }) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios({
    url: `${ApiBasePath}/file/upload`,
    method: 'post',
    data: params,
    onUploadProgress: (e) => {
      const progress = Math.floor(e.loaded * 100 / e.total)
      if (callback) {
        callback(progress)
      }
    }
  })
  return response.data
}
